import createIcon from '../../createIcon';

/**
 * @component @name LocalMall
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNi41SDE3QzE3IDMuNzQgMTQuNzYgMS41IDEyIDEuNUM5LjI0IDEuNSA3IDMuNzQgNyA2LjVINUMzLjkgNi41IDMuMDEgNy40IDMuMDEgOC41TDMgMjAuNUMzIDIxLjYgMy45IDIyLjUgNSAyMi41SDE5QzIwLjEgMjIuNSAyMSAyMS42IDIxIDIwLjVWOC41QzIxIDcuNCAyMC4xIDYuNSAxOSA2LjVaTTEyIDMuNUMxMy42NiAzLjUgMTUgNC44NCAxNSA2LjVIOUM5IDQuODQgMTAuMzQgMy41IDEyIDMuNVpNMTIgMTMuNUM5LjI0IDEzLjUgNyAxMS4yNiA3IDguNUg5QzkgMTAuMTYgMTAuMzQgMTEuNSAxMiAxMS41QzEzLjY2IDExLjUgMTUgMTAuMTYgMTUgOC41SDE3QzE3IDExLjI2IDE0Ljc2IDEzLjUgMTIgMTMuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalMall = createIcon('LocalMall', [
  [
    'path',
    {
      d: 'M19 6.5H17C17 3.74 14.76 1.5 12 1.5C9.24 1.5 7 3.74 7 6.5H5C3.9 6.5 3.01 7.4 3.01 8.5L3 20.5C3 21.6 3.9 22.5 5 22.5H19C20.1 22.5 21 21.6 21 20.5V8.5C21 7.4 20.1 6.5 19 6.5ZM12 3.5C13.66 3.5 15 4.84 15 6.5H9C9 4.84 10.34 3.5 12 3.5ZM12 13.5C9.24 13.5 7 11.26 7 8.5H9C9 10.16 10.34 11.5 12 11.5C13.66 11.5 15 10.16 15 8.5H17C17 11.26 14.76 13.5 12 13.5Z',
      key: '1x1y1z',
    },
  ],
]);

export default LocalMall;
